export const pick = <T extends Record<string, any>, Key extends keyof T>(obj: T, keys: Key[]) =>
  Object.fromEntries(keys.map((k) => [k, obj[k]])) as Pick<T, Key>;
